import { recipesDe } from './recipes-de';
import { batchScalingDe, processRoutingDe } from './process-routing-de';
import { declarationsDe } from './declarations-de';
import { analysisDe } from './analysis-de';

export const plmDe = {
  material: {
    tab: 'Produktentwicklung',
    roles: {
      TRADING_GOOD: 'Handelsware',
      RAW_MATERIAL: 'Rohstoff',
      SEMI_FINISHED: 'Halbfabrikat',
      FINISHED_GOOD: 'Fertigprodukt',
      PACKAGING_MATERIAL: 'Verpackungsmaterial',
      OPERATING_SUPPLY: 'Betriebsstoff',
      BY_PRODUCT: 'Nebenprodukt',
    },
    sections: {
      roles: 'Verwendungsrollen',
      versions: 'Versionierte Stammdatenprofile',
      translations: 'Mehrsprachige Bezeichnungen',
    },
    help: {
      roles:
        'Ein Artikel kann mehrere Rollen gleichzeitig erfüllen. Änderungen werden mit einer Versionsprüfung gespeichert.',
      structuredJson:
        'Strukturierte Schlüssel und Werte als gültiges JSON-Objekt. Zahlen für fachliche Berechnungen als Dezimalzeichenfolge erfassen.',
      conversions:
        'JSON-Liste mit fromUnitCode, toUnitCode, factor, offset, roundingScale und usesDensity.',
      dms: 'Es können ausschließlich Dateien aus der geschützten DMS-Akte dieses Artikels gewählt werden.',
    },
    messages: {
      saved: 'Stammdatenversion gespeichert.',
      invalid: 'Die Eingaben sind ungültig.',
      rolesSaved: 'Verwendungsrollen gespeichert.',
      workflowUpdated: 'Workflow aktualisiert.',
      submitted: 'Version zur Prüfung eingereicht.',
    },
    states: {
      noApproved: 'Es gibt noch keine freigegebene Stammdatenversion.',
      approvedVersion: 'Freigegebene Version: v{{version}}',
      empty: 'Noch keine Stammdatenversion vorhanden.',
      noDocuments: 'In der Artikelakte sind noch keine DMS-Dateien vorhanden.',
    },
    actions: {
      newVersion: 'Neue Version',
      submit: 'Zur Prüfung',
      approve: 'Freigeben',
      copy: 'Neue Version kopieren',
      archive: 'Archivieren',
      confirm: 'Bestätigen',
    },
    columns: {
      version: 'Version',
      status: 'Status',
      validity: 'Gültigkeit',
      names: 'Bezeichnung',
      suppliers: 'Lieferanten-Snapshot',
    },
    statuses: {
      DRAFT: 'Entwurf',
      IN_REVIEW: 'In Prüfung',
      APPROVED: 'Freigegeben',
      SUPERSEDED: 'Ersetzt',
      ARCHIVED: 'Archiviert',
    },
    editor: {
      createTitle: 'Stammdatenversion anlegen',
      editTitle: 'Stammdatenversion v{{version}} bearbeiten',
      description:
        'Freigegebene Versionen sind unveränderlich. Lieferanteninformationen werden beim Speichern serverseitig als Snapshot übernommen.',
    },
    fields: {
      usageRoles: 'Verwendungsrollen',
      standardUnit: 'Standardmengeneinheit',
      shelfLifeDays: 'Haltbarkeit (Tage)',
      density: 'Dichte',
      densityUnit: 'Dichteeinheit',
      originCountry: 'Herkunftsland',
      originRegion: 'Herkunftsregion',
      manufacturer: 'Hersteller',
      manufacturerAddress: 'Herstelleranschrift',
      validFrom: 'Gültig ab',
      validTo: 'Gültig bis',
      internalName: 'Interne Bezeichnung',
      externalName: 'Externe Bezeichnung',
      declarationName: 'Deklarationsbezeichnung',
      storageInstructions: 'Lagerhinweis',
      technicalProperties: 'Technische Eigenschaften',
      qualityProperties: 'Qualitätseigenschaften',
      storageConditions: 'Lagerbedingungen',
      foodProfile: 'Optionales Lebensmittelprofil',
      nutritionProfile: 'Optionales Nährwertprofil',
      allergenInformation: 'Optionale Allergeninformationen',
      additiveInformation: 'Optionale Zusatzstoffinformationen',
      extensionProfiles: 'Branchenspezifische Erweiterungsprofile',
      conversions: 'Artikelbezogene Umrechnungsfaktoren',
      dmsDocuments: 'DMS-Dokumente und Lieferantenspezifikationen',
      changeReason: 'Änderungsgrund',
      reason: 'Begründung',
    },
    actionDialog: {
      APPROVE: {
        title: 'Stammdaten freigeben',
        description:
          'Die Freigabe ist revisionssicher und setzt einen anderen Benutzer als Ersteller und Einreicher voraus.',
      },
      COPY: {
        title: 'Neue Version erzeugen',
        description:
          'Der Inhalt wird in einen neuen bearbeitbaren Entwurf kopiert; Lieferantendaten werden neu snapshotiert.',
      },
      ARCHIVE: {
        title: 'Version archivieren',
        description:
          'Die Version bleibt vollständig nachvollziehbar, wird aber nicht mehr aktiv verwendet.',
      },
    },
  },
  recipes: recipesDe,
  processRouting: processRoutingDe,
  batchScaling: batchScalingDe,
  declarations: declarationsDe,
  analysis: analysisDe,
} as const;
